module.exports = __webpack_public_path__ + "static/media/doublearrowup.724bb78f.svg";